"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class AlertOptionsPhonePreview extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const matchName = {
            notificationAlertOptionPushNotification: {
                description: 'Alert users with a system notification',
                displayText: 'Push Notification',
            },
            notificationAlertOptionNotificationCenter: {
                description: 'Add to your app’s Notification Center',
                displayText: 'Notification Center',
            },
            notificationAlertOptionBadgeNumber: {
                description: "Increment the number on your app's badge icon",
                displayText: 'Badge Number',
            },
        };
        const Fragment = React.Fragment;
        const { device, val } = this.props;
        let view;
        let tempView;
        const getAlertView = () => {
            switch (val) {
                case 'notificationAlertOptionPushNotification':
                case 'systemNotification':
                    return React.createElement(src_1.AlertOptionsPushNotification, null);
                case 'notificationAlertOptionNotificationCenter':
                case 'notificationCenter':
                    return React.createElement(src_1.AlertOptionsNotificationCenter, null);
                case 'notificationAlertOptionBadgeNumber':
                case 'badgeNumber':
                    return React.createElement(src_1.AlertOptionsBadgeNumber, null);
                default:
                    return null;
            }
        };
        let topView = (React.createElement(src_1.PhoneComponent, { viewLockScreen: val === 'notificationAlertOptionPushNotification' || val === 'systemNotification', device: device }, getAlertView()));
        let bottomView = (React.createElement("div", { style: {
                paddingTop: device !== 'Desktop' ? 24 : 40,
                width: val === 'notificationAlertOptionBadgeNumber' ? 200 : 151,
                textAlign: 'center',
                paddingBottom: device === 'Tablet' ? 24 : 0,
            } },
            React.createElement(src_1.Text, { text: matchName[val] && matchName[val].description, size: "large" })));
        if (device !== 'Desktop') {
            tempView = bottomView;
            bottomView = topView;
            topView = tempView;
        }
        view = (React.createElement(Fragment, null,
            topView,
            bottomView));
        if (device === 'Desktop') {
            return view;
        }
        else {
            const { deviceInfoSelected } = this.props;
            let animationVal = 'close';
            if (deviceInfoSelected.length !== 0) {
                animationVal = deviceInfoSelected === 'close' ? 'close' : 'open';
            }
            return (React.createElement("div", { style: {
                    width: '100%',
                    height: '100vh',
                    animation: `${animationVal} 500ms ease`,
                    position: 'absolute',
                    zIndex: 1,
                    top: 0,
                    left: 0,
                    overflowY: device === 'Mobile' ? 'hidden' : 'visible',
                } },
                React.createElement(src_1.NavBar, { buttonLeft: "Close", title: matchName[val] && matchName[val].displayText, buttonLeftCallback: () => this.props.handleAlertOptionsModalDisplay(''), style: {
                        buttonLeftStyle: {
                            outerStyle: {
                                marginLeft: 24,
                            },
                        },
                    } }),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        flexDirection: 'column',
                        width: '100%',
                        height: '100%',
                        background: src_1.white,
                    } }, view)));
        }
    }
}
const mapStateToProps = (state) => ({
    deviceInfoSelected: reducers_1.getIsAlertOptionsOpen(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        handleAlertOptionsModalDisplay: (deviceInfoSelected) => {
            dispatch(actions_1.handleAlertOptionsModalDisplay(deviceInfoSelected));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AlertOptionsPhonePreview);
